<template>
  <article class="CscContact">
    <header-background
      :height="300"
      :image-src="headerImageSrc"
      class="CscContact-Header"
      title="Contato"
    />

    <contact-block
      @alert="handleAlert"
    />
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .CscContact {
    width: 100%;

    &-Header {
      margin-bottom: 20px;
    }
  }
</style>

<script>
  import ContactBlock from "@/components/ContactBlock";
  import HeaderBackground from "@/components/HeaderBackground";

  export default {
    name: "CscContact",

    components: {
      ContactBlock,
      HeaderBackground,
    },

    computed: {
      headerImageSrc() {
        return "/img/backgrounds/csc-01.jpg";
      },
    },

    methods: {
      handleAlert(event) {
        this.$emit("alert", event);
      },
    }
  };
</script>
